import clsx from 'clsx';
import type { OnboardingStatus } from '../../api/client';

const STATUS_STYLES: Record<OnboardingStatus, string> = {
  queued:        'bg-gray-100 text-gray-800',
  sourcing:      'bg-blue-100 text-blue-800',
  extracting:    'bg-blue-100 text-blue-800',
  review_specs:  'bg-yellow-100 text-yellow-800',
  composing:     'bg-blue-100 text-blue-800',
  review_labels: 'bg-yellow-100 text-yellow-800',
  provisioning:  'bg-blue-100 text-blue-800',
  completed:     'bg-green-100 text-green-800',
  failed:        'bg-red-100 text-red-800',
  cancelled:     'bg-gray-100 text-gray-500 line-through',
};

const STATUS_LABELS: Record<OnboardingStatus, string> = {
  queued:        'Queued',
  sourcing:      'Sourcing',
  extracting:    'Extracting',
  review_specs:  'Review Specs',
  composing:     'Composing',
  review_labels: 'Review Labels',
  provisioning:  'Provisioning',
  completed:     'Completed',
  failed:        'Failed',
  cancelled:     'Cancelled',
};

const ACTIVE_STATUSES = new Set<OnboardingStatus>([
  'sourcing', 'extracting', 'composing', 'provisioning',
]);

interface JobStatusBadgeProps {
  status: OnboardingStatus;
  className?: string;
}

export function JobStatusBadge({ status, className }: JobStatusBadgeProps) {
  const isActive = ACTIVE_STATUSES.has(status);

  return (
    <span className={clsx(
      'inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium',
      STATUS_STYLES[status] ?? 'bg-gray-100 text-gray-800',
      className,
    )}>
      {isActive && (
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500" />
        </span>
      )}
      {status === 'review_specs' || status === 'review_labels' ? '★ ' : ''}
      {STATUS_LABELS[status] ?? status}
    </span>
  );
}
